import { makeStyles } from 'tss-react/mui';

interface Props {
  isOnDark: boolean;
}

const useStyles = makeStyles<Props>({ name: 'HighlightTestimonial' })(
  ({ brandColors, breakpoints, spacing, type, typography }, props) => ({
    container: {
      paddingTop: spacing(5),
      paddingBottom: spacing(2),
      overflow: 'hidden',
      backgroundColor: props.isOnDark
        ? brandColors.tintsHeroBlue10
        : brandColors.tintsOffWhite60,
    },
    navigation: {
      display: 'flex',
      justifyContent: 'center',
      gap: spacing(3),
      marginTop: spacing(2),
      cursor: 'pointer',
    },
    navigationButton: {
      width: typography.pxToRem(40),
      height: typography.pxToRem(40),
      [breakpoints.up('sm')]: {
        width: typography.pxToRem(60),
        height: typography.pxToRem(60),
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: typography.pxToRem(800),
      border: `${typography.pxToRem(1)} solid ${brandColors.primaryMain}`,
      color: props.isOnDark ? brandColors.white : brandColors.primaryMain,
      borderColor: props.isOnDark ? brandColors.white : brandColors.primaryMain,
    },
    navigationButtonDisabled: {
      opacity: 0.3,
    },
    hidden: {
      visibility: 'hidden',
    },
    testimonialsContainer: {
      '& .swiper': {
        overflow: 'visible',
      },
      marginTop: spacing(3),
    },
    swiperSlide: {
      height: 'auto',
    },
    testimonialGridContainer: {
      height: '100%',
    },
    testimonial: {
      borderRadius: typography.pxToRem(16),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: `${spacing(4)} ${spacing(1)}`,
      [breakpoints.up('sm')]: { padding: `${spacing(4)} ${spacing(5)}` },
      backgroundColor: props.isOnDark
        ? brandColors.tintsMediumBlue20
        : brandColors.tintsHeroBlue90,
    },
    testimonialText: {
      textAlign: 'center',
      color: props.isOnDark
        ? brandColors.tintsChargeBlue60
        : brandColors.tintsHeroBlue40,
      ...type['24_regular'],
      [breakpoints.up('sm')]: {
        ...type['40_regular'],
      },
      [breakpoints.up('lg')]: {
        fontSize: typography.pxToRem(44),
        lineHeight: '110%',
        letterSpacing: typography.pxToRem(-0.88),
      },
    },
    quoteAttribution: {
      textAlign: 'center',
      marginTop: spacing(0),
      color: props.isOnDark
        ? brandColors.tintsChargeBlue70
        : brandColors.tintsChargeBlue20,
    },
    starQuoteContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column-reverse',
    },
    chips: {
      marginTop: spacing(2),
      display: 'flex',
      justifyContent: 'center',
      gap: spacing(0),
      flexWrap: 'wrap',
    },
    chip: {
      '&.MuiChip-root': {
        ...type['16_regular'],
        [breakpoints.up('md')]: {
          ...type['18_regular'],
        },
        color: props.isOnDark ? brandColors.primaryMain : brandColors.white,
        backgroundColor: props.isOnDark
          ? brandColors.tintsChargeBlue60
          : brandColors.tintsChargeBlue20,
        '& span': {
          padding: `${typography.pxToRem(4)} ${spacing(0)}}`,
        },
      },
    },
    horizontal: {
      display: 'flex',
    },
    pagination: {
      width: 'fit-content!important',
      display: 'flex',
      alignItems: 'center',
      gap: spacing(0),
      '& .bullet': {
        color: props.isOnDark
          ? brandColors.tintsHeroBlue60
          : brandColors.tintsHeroBlue80,
      },
      '& .bullet-active': {
        color: props.isOnDark ? brandColors.white : brandColors.primaryMain,
      },
    },
    cta: {
      [breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
      },
    },
    button: {
      marginTop: spacing(2),
      [breakpoints.up('md')]: {
        marginTop: 0,
      },
    },
  })
);

export default useStyles;
